import React from "react";
import PropTypes from "prop-types";
import {
  truncateHgvsP1,
  truncateHgvsP3,
} from "../../../../components/TruncatedText/helpers";
import TruncatedText from "../../../../components/TruncatedText/TruncatedText";

/**
 * Displays protein change information using item's `hgvs_p1` and `hgvs_p3` fields.
 *
 * - If `hgvs_p1` equals `"p.?"`, the component returns `"p.?"` to indicate unknown protein change.
 * - If either `hgvs_p1` or `hgvs_p3` is available, the component concatenates them.
 * - If both fields are absent, it returns `"-"` as an indication of missing data.
 *
 * `hgvs_p1` uses single-letter amino acid abbreviations, while `hgvs_p3` uses three-letter abbreviations.
 */

const ProteinLevel = ({ isFLT3ITD, item }) => {
  const { hgvs_p1: p1, hgvs_p3: p3 } = item || {};

  if (p1 === "p.?") return p1;
  if (p1 || p3) {
    const originalValue = `${p1 || ""} ${p3 || ""}`.trim();
    const truncatedValue = `${truncateHgvsP1(p1) || ""} ${
      truncateHgvsP3(p3) || ""
    }`.trim();

    if (isFLT3ITD && truncatedValue !== originalValue) {
      return (
        <TruncatedText
          truncatedText={truncatedValue}
          originalText={originalValue}
        />
      );
    }
    return originalValue;
  }
  return "-";
};

ProteinLevel.propTypes = {
  isFLT3ITD: PropTypes.bool,
  item: PropTypes.shape({
    hgvs_p1: PropTypes.string,
    hgvs_p3: PropTypes.string,
  }),
};

ProteinLevel.defaultProps = {
  isFLT3ITD: false,
  item: null,
};

export default React.memo(ProteinLevel);
